// Flow types automatically removed

import { Button } from 'dibs-elements/exports/Button.tsx';
import formStyles from '../styles/FormGeneral.scss';
import classnames from 'classnames';
export const MatchmakerButton = ({ buttonName, classNames, onClick }) => {
    return (
        <div className={classnames(classNames, formStyles.ctaButton)}>
            <Button onClick={onClick} dataTn="matchmaker-formSubmit" size="large" fullWidth>
                {buttonName}
            </Button>
        </div>
    );
};
